module.exports = __webpack_public_path__ + "static/img/ico.c011e3a6.png";